import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WorkoutLevels } from '@guryou/core';
const useExerciseLevels = () => {
  const {
    t
  } = useTranslation();
  const [levels, setLevels] = useState();
  const defaultValues = [{
    label: t('EXERCISE.allLevels'),
    value: WorkoutLevels.allLevels
  }, {
    label: t('EXERCISE.beginner'),
    value: WorkoutLevels.beginner
  }, {
    label: t('EXERCISE.intermediate'),
    value: WorkoutLevels.intermediate
  }, {
    label: t('EXERCISE.expert'),
    value: WorkoutLevels.expert
  }, {
    label: t('EXERCISE.athlete'),
    value: WorkoutLevels.athlete
  }];
  if (!levels) {
    setLevels(defaultValues);
  }
  return levels;
};
export { useExerciseLevels };